import * as L from 'leaflet'
import { SearchResultRow } from '../../../../generic-search-common/src'

interface DataMarkerOptions extends L.MarkerOptions {
  data?: SearchResultRow
}

export class DataMarker extends L.Marker {
  data?: SearchResultRow

  constructor(latLng: L.LatLngExpression, options?: DataMarkerOptions) {
    super(latLng, options)
    this.setData(options?.data)
  }

  getData() {
    return this.data
  }

  setData(data: any) {
    this.data = data
  }
}
